import { RootState } from '@/store/store';
import { createSlice } from '@reduxjs/toolkit';
import { IBrowser, IDevice, IEngine, IOS } from 'ua-parser-js';
import { analyticReducer } from './reducer';

export const ANALYTIC_KEY = 'app::analytic';
export type UaInfo = {
    browser: IBrowser;
    device: IDevice;
    os: IOS;
    engine: IEngine;
};
export type UserInfoInfo = {
    playerID: number;
    lobbyCode: string;
    currency: string;
};
export type LocationInfo = {
    ip: string;
    location: string;
};
export type Analytic = {
    clientType: 'rwd';
    // account info
    playerID: number;
    lobbyCode: string;
    minBet: number;
    maxBet: number;
    currency: string;
    isMultiBet: boolean;
    isLandscape: boolean;
    // client setting
    apiUrl: string;
    locale: string;
    voiceOver: string;
    // js api get screen info
    innerWidth: number;
    innerHeight: number;
    deviceRatio: number;
    // ua info
    deviceType: string;
    browser: string;
    browserVersion: string;
    os: string;
    osVersion: string;
};
const initialAnalyticState = {
    apiUrl: '',
    minBet: 0,
    maxBet: 0,
    isMultiBet: false,
    isLandscape: false,
    locale: '',
    currency: '',
    innerWidth: 0,
    innerHeight: 0,
    deviceType: '',
    deviceRatio: 1,
    browser: '',
    browserVersion: '',
    os: '',
    osVersion: '',
} as Analytic;

const analyticSlice = createSlice({
    name: ANALYTIC_KEY,
    initialState: initialAnalyticState,
    reducers: analyticReducer,
});
export const analyticSliceReducer = analyticSlice.reducer;
export const analyticSliceActions = analyticSlice.actions;
export const getAnalytic = (state: RootState): Analytic => state[ANALYTIC_KEY];
